export type AppServiceId =
  | 'home'
  | 'oneGUI'
  | 'watchfolder'
  | 'fileQueuer'
  | 'ingest'
  | 'recorder'
  | 'complianceMonitoring'
  | 'compliancePlayer'
  | 'complianceRecord';

const buildType = (process.env.REACT_APP_BUILD_TYPE ?? 'development').trim().toLowerCase();
const activeModulesValue = (process.env.REACT_APP_ACTIVE_MODULES ?? '').trim();
const defaultHiddenSettingsTabs = 'settings,users,resources,permissions,services,licenses';
const hiddenSettingsTabsValue = process.env.REACT_APP_HIDDEN_SETTINGS_TABS ?? defaultHiddenSettingsTabs;

export const isProductionBuild = buildType === 'production';
// `npm start` always sets NODE_ENV to development. Allow the explicit build
// type to exercise production authentication without creating a build first.
export const isDevelopmentMode = process.env.NODE_ENV === 'development' && !isProductionBuild;

const hiddenSettingsTabs = new Set(
  hiddenSettingsTabsValue
    .split(',')
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean)
);

export const isSettingsTabEnabledByBuild = (settingsTabId: string): boolean =>
  !isProductionBuild || !hiddenSettingsTabs.has(settingsTabId.toLowerCase());

const moduleAliases: Record<string, AppServiceId[]> = {
  home: ['home'],
  jobmonitor: ['oneGUI'],
  onegui: ['oneGUI'],
  transcode: ['watchfolder'],
  watchfolder: ['watchfolder'],
  filequeuer: ['fileQueuer'],
  queuer: ['fileQueuer'],
  ingest: ['ingest'],
  upload: ['ingest'],
  record: ['recorder'],
  recorder: ['recorder'],
  compliancemonitoring: ['complianceMonitoring'],
  monitoring: ['complianceMonitoring'],
  complianceplayer: ['compliancePlayer'],
  player: ['compliancePlayer'],
  compliancerecord: ['complianceRecord'],
};

const resolvedActiveServices = new Set<AppServiceId>();

activeModulesValue
  .split(',')
  .map((entry) => entry.trim().toLowerCase())
  .filter(Boolean)
  .forEach((entry) => {
    const mappedServices = moduleAliases[entry];
    mappedServices?.forEach((serviceId) => resolvedActiveServices.add(serviceId));
  });

export const hasExplicitActiveModules = resolvedActiveServices.size > 0;

export const isServiceEnabledByBuild = (serviceId: AppServiceId): boolean => {
  if (serviceId === 'home') {
    return true;
  }

  if (!isProductionBuild || !hasExplicitActiveModules) {
    return true;
  }

  return resolvedActiveServices.has(serviceId);
};
